  // tab slider js
$('.tab_slider_main').slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});


// review slider js
$('.reviews-slider').slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
      }
    }
  ]
});


function initInstaSlider() {
  if ($(window).width() <= 600) {
    if (!$('.instablock').hasClass('slick-initialized')) {
      $('.instablock').slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 600,
        slidesToShow: 2,
        slidesToScroll: 1
      });
    }
  } else {
    if ($('.instablock').hasClass('slick-initialized')) {
      $('.instablock').slick('unslick');
    }
  }
}

// Run on load
initInstaSlider();

// Run on resize
$(window).on('resize', function () {
  initInstaSlider();
});

  // // logos  js
  // $('.client-logos-grid').marquee({
  //   direction: 'left',
  //   duration: 20000,
  //   delayBeforeStart: 0,
  //   pauseOnHover: true,
  //   duplicated: true,
  //   startVisible: true
  // });


  // icon with text js
  $('.icon_with_text_inner').marquee({
    direction: 'left',
    duration: 20000,
    delayBeforeStart: 0,
    pauseOnHover: true,
    duplicated: true,
    startVisible: true
  });


$('.gallery-grid_main').slick({
 dots: false,
  arrows: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 5,
  slidesToScroll: 1,
  centerMode: true,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

$('.Best_seller_sc .product-grid').slick({
 dots: false,
  arrows: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

